import * as React from 'react';
import {IDismissedTimeline} from 'features/channelTimelines/channelTimelinesApi';

interface UseDismissedNotification {
  dismissed: IDismissedTimeline[];
  showModal: boolean;
  setShowModal: (val: boolean) => void;
  onDismissedChange: (dismissed: IDismissedTimeline[]) => void;
}

// Tracks slots whose episode was deleted and decides when to surface the gap notification.
// The modal opens once per distinct set of dismissed episodes (so re-entering or refetching the
// draft doesn't re-alert for the same gaps), and resets once there are no dismissed slots left.
export function useDismissedNotification(): UseDismissedNotification {
  const [dismissed, setDismissed] = React.useState<IDismissedTimeline[]>([]);
  const [showModal, setShowModal] = React.useState(false);
  const shownSignatureRef = React.useRef<string>('');

  const onDismissedChange = React.useCallback((next: IDismissedTimeline[]) => {
    setDismissed(next);

    if (next.length === 0) {
      shownSignatureRef.current = '';
      setShowModal(false);
      return;
    }

    const signature = next
      .map(d => d.episodeId)
      .sort()
      .join(',');
    if (signature !== shownSignatureRef.current) {
      shownSignatureRef.current = signature;
      setShowModal(true);
    }
  }, []);

  return {dismissed, showModal, setShowModal, onDismissedChange};
}
